export enum UserType {
  client = 100,
  provider = 200,
  manager = 300,
}
